import React, { useState,useEffect } from "react";
import { 
  Box,
  MenuItem, 
  Select,
  FormControl,
  InputLabel,
  Popover,
  Button,
  useTheme,
  useMediaQuery,
  Typography,
  TextField,
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,
  TablePagination, 
  Paper,} from "@mui/material";
import { DateRange,Calendar } from "react-date-range";
import { addDays ,format} from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import SingleDatePicker from "./SingleDatePicker";
import RecordTable from "./RecordTable";
import { useTranslation } from "react-i18next";

const Records = () => {
  const [recordType, setRecordType] = useState("referral");
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const [status, setStatus] = useState("ALL");
  const [preset, setPreset] = useState("today");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [anchorElStart, setAnchorElStart] = useState(null);
  const [anchorElEnd, setAnchorElEnd] = useState(null);
  const { t } = useTranslation();
 const isLightTheme = process.env.REACT_APP_IS_LIGHT_THEME === "true";

  const [queryParams, setQueryParams] = useState({
    recordType: 'referral',
    status: status,
    startDate: null,
    endDate: null,
  });

  // Date range state (default to 1 week ago to today)
  const [dateRange, setDateRange] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  // Popover state
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenDate = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseDate = () => {
    setAnchorEl(null);
  };

  //Date presets
    useEffect(() => {
    const today = new Date();
    let newStartDate = today;
    
    if (preset === '3days') {
      newStartDate = addDays(today, -2); // Today, yesterday, the day before
    } else if (preset === '1week') {
      newStartDate = addDays(today, -6);
    } else if (preset === '1month') {
      newStartDate = addDays(today, -29);
    }
    
    setStartDate(newStartDate);
    setEndDate(today);

    setDateRange([{
      startDate: newStartDate,
      endDate: today,
      key: 'selection'
    }]);
  }, [preset]);

// Refactored submission logic
const submitDateQuery = (start, end) => {
  const formattedStartDate = start ? format(start, 'yyyy-MM-dd') : null;
  const formattedEndDate = end ? format(end, 'yyyy-MM-dd') : null;

  setQueryParams({
    recordType: recordType,
    status: 'ALL', 
    startDate: formattedStartDate,
    endDate: formattedEndDate,
  });

  console.log("Submitting with dates:", {
    startDate: formattedStartDate,
    endDate: formattedEndDate
  });
};

const handleManualSubmit = () => {
  submitDateQuery(startDate, endDate);
};

useEffect(() => {

  if (startDate && endDate) {
    submitDateQuery(startDate, endDate);
  }

}, [startDate, endDate]);

  const open = Boolean(anchorEl);
  const id = open ? "date-range-popover" : undefined;

  const formatDate = (date) =>
    date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });

  return (
  <>
    {mobileView ? (
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
        sx={{ mb: 2 }}
      >
        {/* Record Type Dropdown */}
        <FormControl sx={{ minWidth: 200, flex: 1, maxWidth: 250 }}>
          <InputLabel id="record-type-label" sx={{color:isLightTheme?"black":"white"}}>{t("referral.recordtype")}</InputLabel>
          <Select
            labelId="record-type-label"
            value={recordType}
            label="Record Type"
             sx={{ 
              color:isLightTheme?"black":"white",

              '.MuiOutlinedInput-notchedOutline': {
              borderColor: isLightTheme ? "black" : "white",
            },
            
            }}
            onChange={(e) => setRecordType(e.target.value)}
            size="small"
          >
            <MenuItem value="referral">{t("referral.referralbonus")}</MenuItem>
            {/* <MenuItem value="achievement">{t("referral.achievementrewards")}</MenuItem> */}
            <MenuItem value="commission">{t("referral.referralcommission")}</MenuItem>
          </Select>
        </FormControl>

        {/* Date Range Button */}
        <Box sx={{ flex: 1, maxWidth: 250 }}>
          <Button
            variant="outlined"
            onClick={handleOpenDate}
            size="small"
            fullWidth
            sx={{ textTransform: "none",color:isLightTheme?"black":"white", borderColor: isLightTheme ? "black" : "white", }}
          >
            {`${formatDate(dateRange[0].startDate)} - ${formatDate(dateRange[0].endDate)}`}
          </Button>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleCloseDate}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <DateRange
              editableDateInputs={true}
              onChange={(item) => setDateRange([item.selection])}
              moveRangeOnFirstSelection={false}
              ranges={dateRange}
            />
          </Popover>
        </Box>
      </Box>
    ) : (
 <Box px={4} py={2} mt={5}>
    <Box display="flex" flexDirection="column" gap={2} mb={4}>
      {/* Row 1: Record Type */}
      <Box display="flex" alignItems="center" gap={2}>
        <Box sx={{ width: 150 }}>
          <Typography sx={{ color:isLightTheme?"black":"white"}}>{t("referral.recordtype")}:</Typography>
        </Box>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel sx={{ color:isLightTheme?"black":"white"}}>{t("referral.recordtype")}</InputLabel>
          <Select
            value={recordType}
            label="Record Type"
            sx={{ 
              color:isLightTheme?"black":"white",

              '.MuiOutlinedInput-notchedOutline': {
              borderColor: isLightTheme ? "black" : "white",
            },

            }}
            onChange={(e) => setRecordType(e.target.value)}
          >
            <MenuItem value="referral">{t("referral.referralbonus")}</MenuItem>
            {/* <MenuItem value="achievement">{t("referral.achievementrewards")}</MenuItem> */}
            <MenuItem value="commission">
              {t("referral.referralcommission")}
            </MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* Row 2: Date Presets */}
      <Box display="flex" alignItems="center" gap={2}>
        <Box sx={{ width: 150 }}>
          <Typography sx={{ color:isLightTheme?"black":"white"}}>{t("referral.transactiondate")}</Typography>
        </Box>
      <Box display="flex" gap={1}>
        {["today", "3days", "1week", "1month"].map((label) => {
          const translationKey = {
            today: "referral.presettoday",
            "3days": "referral.presetthreedays",
            "1week": "referral.presetoneweek",
            "1month": "referral.presetonemonth",
          }[label];

          return (
            <Button
              key={label}
              variant={preset === label ? "contained" : "outlined"}
              size="small"
              sx={{ 
                color:isLightTheme?"black":"white",
                borderColor: isLightTheme ? "black" : "white",
              }}
              onClick={() => setPreset(label)}
            >
              {t(translationKey)}
            </Button>
          );
        })}
      </Box>
      </Box>

      {/* Row 3: Status */}
        {recordType === 'referral' ? (
          <>
      <Box display="flex" alignItems="center" gap={2}>
        <Box sx={{ width: 150 }}>
          <Typography sx={{ color:isLightTheme?"black":"white"}}>{t("referral.status")}:</Typography>
        </Box>
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel sx={{ color:isLightTheme?"black":"white"}}>{t("referral.status")}</InputLabel>
          <Select
            value={status}
            label="Status"
             sx={{ 
              color:isLightTheme?"black":"white",

              '.MuiOutlinedInput-notchedOutline': {
              borderColor: isLightTheme ? "black" : "white",
            },
            
            }}
            onChange={(e) => setStatus(e.target.value)}
          >
            <MenuItem value="ALL">{t("referral.statusall")}</MenuItem>
            <MenuItem value="ONGOING">{t("referral.statusongoing")}</MenuItem>
            <MenuItem value="COMPLETED">{t("referral.statuscompleted")}</MenuItem>
          </Select>
        </FormControl>
      </Box>
      </>
        ) : null }
      {/* Row 4: Date Range */}
      <Box display="flex" alignItems="center" gap={2}>
        <Box sx={{ width: 150 }}>
          <Typography sx={{ color:isLightTheme?"black":"white"}}>{t("referral.daterange")}:</Typography>
        </Box>
        <SingleDatePicker
          label=""
          selectedDate={startDate}
          setSelectedDate={setStartDate}
          anchorEl={anchorElStart}
          setAnchorEl={setAnchorElStart}
        />

        <Typography sx={{ color:isLightTheme?"black":"white"}}>to</Typography>

        <SingleDatePicker
          label=""
          selectedDate={endDate}
          setSelectedDate={setEndDate}
          anchorEl={anchorElEnd}
          setAnchorEl={setAnchorElEnd}
        />
        <Button variant="contained" size="small" onClick={handleManualSubmit}>
          {t("referral.submit")}
        </Button>
      </Box>
    </Box>

      {/* Bottom Data Table Section */}
      <Box mt={4}>
        <RecordTable 
        value={recordType}
        startDate={queryParams.startDate}
        endDate={queryParams.endDate}
        status={status}
        >
        </RecordTable>
      </Box>
    </Box>
      
    )}
  </>
);

};

export default Records;
